import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {PageComponent} from "./page/page.component";
import {LoginPageComponent} from "./login/login-page/login-page.component";
import {UserProfileChromeControlComponent} from "./user-profile/user-profile-chrome-control/user-profile-chrome-control.component";
import {SearchGridComponent} from "./search/search-grid/search-grid.component";
import {SearchPageComponent} from "./search/search-page/search-page.component";
import {UserSearchPageComponent} from "./user/user-search/user-search-page.component";
import {UserEditPageComponent} from "./user/user-edit/user-edit-page.component";
import {RemoveButtonComponent} from "./controls/remove-button/remove-button.component";
import {ActionButtonsComponent} from "./controls/action-buttons/action-buttons.component";
import {TimezoneSelectControlComponent} from "./controls/timezone-select-control/timezone-select-control.component";
import {ProvisionButtonComponent} from "./controls/provision-button/provision-button.component";
import {InvoiceReportPageComponent} from "./report/invoice-report/invoice-report-page.component";
import {CustomerInstanceEditPageComponent} from "./customer-instance/customer-instance-edit/customer-instance-edit-page.component";
import {CustomerInstanceSearchPageComponent} from "./customer-instance/customer-instance-search/customer-instance-search-page.component";
import {CustomerInstanceVenueEditPageComponent} from "./customer-instance-venue/customer-instance-venue-edit/customer-instance-venue-edit-page.component";
import {StatusPanelComponent} from "./content-layout/status-panel/status-panel.component";
import {VenueContactComponent} from "./customer-instance-venue/venue-contact/venue-contact.component";
import {StatusPanelEditComponent} from "./content-layout/status-panel/status-panel-edit-content/status-panel-edit-content.component";
import {StatusPanelViewComponent} from "./content-layout/status-panel/status-panel-view-content/status-panel-view-content.component";
import {UserSelectControlComponent} from "./controls/user-select-control/user-select-control.component";
import {BillingDirectDebitFormComponent} from "./customer-instance-venue/billing-account/billing-direct-debit-form.component";
import {SignupPageComponent} from "./signup/signup-page/signup-page.component";
import {VenuePlanComponent} from "./customer-instance-venue/venue-plan/venue-plan.component";
import {VenuePlanSelectControlComponent} from "./controls/venue-plan-select-control/venue-plan-select-control.component";
import {BillingAccountComponent} from "./customer-instance-venue/billing-account/billing-account.component";
import {CustomerInstanceSelectControlComponent} from "./controls/customer-instance-select-control/customer-instance-select-control.component";
import {ContractFormComponent} from "./customer-instance-venue/contract/contract-form.component";
import {VenueAddressComponent} from "./customer-instance-venue/venue-address/venue-address.component";
import {StateSelectControlComponent} from "./controls/state-select-control/state-select-control.component";
import {VenueCompanyComponent} from "./customer-instance-venue/venue-company/venue-company.component";
import {CustomerInstanceVenueSearchPageComponent} from "./customer-instance-venue/customer-instance-venue-search/customer-instance-venue-search-page.component";
import {VenueDeploymentStatusSelectControlComponent} from "./controls/venue-deployment-status-select-control/venue-deployment-status-select-control.component";
import {MenuComponent} from "./customer-instance-venue/menu/menu.component";
import {VenueServicesComponent} from "./customer-instance-venue/venue-services/venue-services.component";
import {SignupModalComponent} from "./customer-instance-venue/signup/signup-modal.component";
import {SignupPageModalComponent} from "./signup/signup-page-modal/signup-page-modal.component";
import {SignupPageContentComponent} from "./signup/signup-page-content/signup-page-content.component";
import {SignupStatusComponent} from "./customer-instance-venue/signup-status/signup-status.component";
import {VenueCardVerificationComponent} from "./customer-instance-venue/venue-card-verification/venue-card-verification.component";
import {CustomerPortalPageContentComponent} from "./customer-portal/customer-portal-page-content/customer-portal-page-content.component";
import {CustomerPortalPageComponent} from "./customer-portal/customer-portal/customer-portal-page.component";
import {VenueSelectControlComponent} from "./controls/venue-select-control/venue-select-control.component";
import {VenueSyncPaymentsSearchPageComponent} from "./venue-sync/venue-sync-payments-search/venue-sync-payments-search-page.component";
import {AppPaymentAccountPageComponent} from "./app-payment-account/app-payment-account-page/app-payment-account-page.component";
import {AppPaymentAccountPageContentComponent} from "./app-payment-account/app-payment-account-page-content/app-payment-account-page-content.component";
import {AppPaymentAccountPageModalComponent} from "./app-payment-account/app-payment-account-page-modal/app-payment-account-page-modal.component";
import {SignupUrlComponent} from "./customer-instance-venue/signup/signup-url.component";
import {CustomerInstanceVenueManagerSearchPageComponent} from "./customer-instance-venue/customer-instance-venue-manager-search/customer-instance-venue-manager-search-page.component";
import {SalesHandoverComponent} from "./customer-instance-venue/sales-handover/sales-handover.component";
import {VenueRequireActionMultiSelectControlComponent} from "./controls/venue-require-action-multi-select-control/venue-require-action-multi-select-control.component";
import {DisputeEvidenceSubmitPageComponent} from "./dispute/dispute-evidence-submit/dispute-evidence-submit-page.component";
import {EvidenceTypeSelectControlComponent} from "./dispute/controls/evidence-type-control/evidence-type-select-control.component";
import {PartnerSearchPageComponent} from "./partner/partner-search/partner-search-page.component";
import {PartnerEditPageComponent} from "./partner/partner-edit/partner-edit-page.component";
import {PartnerSelectControlComponent} from "./controls/partner-select-control/partner-select-control.component";
import {VenueSignupReportPageComponent} from "./report/venue-signup-report/venue-signup-report-page.component";
import {CustomerInstanceGroupEditPageComponent} from "./customer-instance-group/customer-instance-group-edit/customer-instance-group-edit-page.component";
import {CustomerInstanceGroupSearchPageComponent} from "./customer-instance-group/customer-instance-group-search/customer-instance-group-search-page.component";
import {CustomerInstanceGroupSelectControlComponent} from "./controls/customer-instance-group-select-control/customer-instance-group-select-control.component";
import {SubscriptionTypeSelectControlComponent} from "./controls/subscription-type-select-control/subscription-type-select-control.component";
import {PlanUpdateBatchJobPageComponent} from "./batch/plan-update-batch-job/plan-update-batch-job-page.component";
import {VenuePlanManagementComponent} from "./customer-instance-venue/venue-plan-management/venue-plan-management.component";
import {BackupPageComponent} from "./admin/backup/backup-page.component";
import {
    CancelReasonsSelectControlComponent
} from "./controls/cancel-reasons-select-control/cancel-reasons-select-control.component";


@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        PageComponent,
        LoginPageComponent,
        SignupPageComponent,
        SignupPageContentComponent,
        SignupModalComponent,
        SignupUrlComponent,
        SignupPageModalComponent,
        CustomerPortalPageComponent,
        CustomerPortalPageContentComponent,
        UserProfileChromeControlComponent,
        SearchPageComponent,
        SearchGridComponent,
        UserSearchPageComponent,
        PartnerSearchPageComponent,
        PartnerEditPageComponent,
        UserEditPageComponent,
        RemoveButtonComponent,
        ActionButtonsComponent,
        TimezoneSelectControlComponent,
        StateSelectControlComponent,
        CancelReasonsSelectControlComponent,
        SubscriptionTypeSelectControlComponent,
        UserSelectControlComponent,
        PartnerSelectControlComponent,
        VenuePlanSelectControlComponent,
        VenueDeploymentStatusSelectControlComponent,
        VenueRequireActionMultiSelectControlComponent,
        CustomerInstanceSelectControlComponent,
        CustomerInstanceGroupSelectControlComponent,
        ContractFormComponent,
        VenueContactComponent,
        VenueAddressComponent,
        VenueCardVerificationComponent,
        SignupStatusComponent,
        VenueCompanyComponent,
        VenuePlanComponent,
        VenuePlanManagementComponent,
        VenueServicesComponent,
        BillingAccountComponent,
        BillingDirectDebitFormComponent,
        ProvisionButtonComponent,
        StatusPanelComponent,
        StatusPanelEditComponent,
        StatusPanelViewComponent,
        InvoiceReportPageComponent,
        VenueSignupReportPageComponent,
        PlanUpdateBatchJobPageComponent,
        CustomerInstanceGroupSearchPageComponent,
        CustomerInstanceGroupEditPageComponent,
        CustomerInstanceEditPageComponent,
        CustomerInstanceSearchPageComponent,
        CustomerInstanceVenueEditPageComponent,
        CustomerInstanceVenueSearchPageComponent,
        CustomerInstanceVenueManagerSearchPageComponent,
        MenuComponent,
        VenueSyncPaymentsSearchPageComponent,
        VenueSelectControlComponent,
        AppPaymentAccountPageComponent,
        AppPaymentAccountPageContentComponent,
        AppPaymentAccountPageModalComponent,
        SalesHandoverComponent,
        DisputeEvidenceSubmitPageComponent,
        EvidenceTypeSelectControlComponent,
        BackupPageComponent
    ],
    exports: [
        PageComponent,
        LoginPageComponent,
        SignupPageComponent,
        SignupPageContentComponent,
        SignupModalComponent,
        SignupUrlComponent,
        SignupPageModalComponent,
        CustomerPortalPageComponent,
        CustomerPortalPageContentComponent,
        UserProfileChromeControlComponent,
        SearchPageComponent,
        SearchGridComponent,
        UserSearchPageComponent,
        PartnerSearchPageComponent,
        PartnerEditPageComponent,
        UserEditPageComponent,
        RemoveButtonComponent,
        ActionButtonsComponent,
        TimezoneSelectControlComponent,
        StateSelectControlComponent,
        CancelReasonsSelectControlComponent,
        SubscriptionTypeSelectControlComponent,
        UserSelectControlComponent,
        PartnerSelectControlComponent,
        VenuePlanSelectControlComponent,
        VenueDeploymentStatusSelectControlComponent,
        VenueRequireActionMultiSelectControlComponent,
        CustomerInstanceSelectControlComponent,
        CustomerInstanceGroupSelectControlComponent,
        ContractFormComponent,
        VenueContactComponent,
        VenueAddressComponent,
        VenueCardVerificationComponent,
        SignupStatusComponent,
        VenueCompanyComponent,
        VenuePlanComponent,
        VenuePlanManagementComponent,
        VenueServicesComponent,
        BillingAccountComponent,
        BillingDirectDebitFormComponent,
        ProvisionButtonComponent,
        StatusPanelComponent,
        StatusPanelEditComponent,
        StatusPanelViewComponent,
        InvoiceReportPageComponent,
        VenueSignupReportPageComponent,
        PlanUpdateBatchJobPageComponent,
        CustomerInstanceGroupSearchPageComponent,
        CustomerInstanceGroupEditPageComponent,
        CustomerInstanceEditPageComponent,
        CustomerInstanceSearchPageComponent,
        CustomerInstanceVenueEditPageComponent,
        CustomerInstanceVenueSearchPageComponent,
        CustomerInstanceVenueManagerSearchPageComponent,
        MenuComponent,
        VenueSyncPaymentsSearchPageComponent,
        VenueSelectControlComponent,
        AppPaymentAccountPageComponent,
        AppPaymentAccountPageContentComponent,
        AppPaymentAccountPageModalComponent,
        SalesHandoverComponent,
        DisputeEvidenceSubmitPageComponent,
        EvidenceTypeSelectControlComponent,
        BackupPageComponent
    ],
    providers: []
})

export class HostManagerModule {
}
